import { DateTime } from "luxon";
import { Article } from "../types/Article";
import { deleteDoc, doc, getDoc, getFirestore, writeBatch } from "firebase/firestore";
import { articleConverter } from "../converters/articleConverter";


export const draftArticle = async (article: Article, publishedArticle?: Article) => {
    let draft: Article = {
        ...article,
        deepLink: article.deepLink.trim() === ""
            ? publishedArticle && publishedArticle.deepLink.trim() === ""
                ? `https://nadafa-ems.web.app/articles/${article.id}`
                : publishedArticle?.deepLink ?? `https://nadafa-ems.web.app/articles/${article.id}`
            : article.deepLink,
        published: {
            isPublished: false,
            publishedTime: DateTime.now(),
        },
        lastUpdate: DateTime.now(),
    }

    const db = getFirestore();

    const batch = writeBatch(db);
    try {
        const draftDocRef = doc(db, `ArticlesDrafts/${draft.id}`).withConverter(articleConverter);
        batch.set(draftDocRef, draft, { merge: true });

        if (publishedArticle === undefined) {
            const docRef = doc(db, `Articles/${draft.id}`).withConverter(articleConverter);
            batch.set(docRef, draft, { merge: true });
        }

        await batch.commit()
        return draft;
    } catch (e) {
        throw e;
    }
};

export const publishArticle = async (draft: Article) => {
    let article: Article = {
        ...draft,
        deepLink: draft.deepLink.trim() === ""
            ? `https://nadafa-ems.web.app/articles/${draft.id}`
            : draft.deepLink,
        published: {
            isPublished: true,
            publishedTime: DateTime.now(),
        },
        lastUpdate: DateTime.now(),
    };

    const db = getFirestore();
    const batch = writeBatch(db);
    try {
        const docRef = doc(db, `Articles/${article.id}`).withConverter(articleConverter);
        const draftDocRef = doc(db, `ArticlesDrafts/${article.id}`).withConverter(articleConverter);
        batch.set(docRef, article, { merge: true });
        batch.delete(draftDocRef);
        await batch.commit();
        return article;
    } catch (e) {
        throw e;
    }
};

export const unpublishArticle = async (article: Article) => {
    let unpublish: Article = {
        ...article,
        deepLink: article.deepLink.trim() === ""
            ? `https://nadafa-ems.web.app/articles/${article.id}`
            : article.deepLink,
        published: {
            isPublished: false,
            publishedTime: DateTime.now(),
        },
        lastUpdate: DateTime.now(),
    }

    const db = getFirestore();
    const batch = writeBatch(db);
    try {
        const docRef = doc(db, `Articles/${unpublish.id}`).withConverter(articleConverter);
        batch.set(docRef, unpublish, { merge: true });
        await batch.commit();
        return unpublish;
    } catch (e) {
        throw e;
    }
};

export const deleteDraftArticle = async (article: Article) => {
    const db = getFirestore();
    const publishRef = doc(db, `Articles/${article.id}`);

    // Get the article in Articles collection, check if article is not publish, if not
    // delete also the article in Articles collection
    const publishDoc = await getDoc(publishRef.withConverter(articleConverter));
    if (publishDoc.exists()) {
        const a = publishDoc.data();
        if (!a.published.isPublished) {
            // Not yet published, delete this draft
            await deleteDoc(publishRef)
        }
    }

    const draftRef = doc(db, `ArticlesDrafts/${article.id}`);
    await deleteDoc(draftRef);
};